import MultiplePlaylistsTiles from './MultiplePlaylistsTiles'

export default MultiplePlaylistsTiles
// eslint-disable-next-line import/export
export * from './MultiplePlaylistsTiles'
